import ApiClient from "core/client";

const client = new ApiClient(import.meta.env.VITE_HOST + "/api");

export default client;